import { createRoutine } from 'redux-saga-routines'

export const SET = 'TIENDITA_LAYOUT/SET'
export const CONTENT = createRoutine('TIENDITA_LAYOUT/CONTENT')
